import React, { useCallback, useState } from "react";
import client from "@culturehq/client";
import { ActionButton, Loader, Panel, SearchBar, Table, Tag, Thumbnail, Warning } from "@culturehq/components";

import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import getUserName from "app/utils/getUserName";
import Simulate from "./Simulate";

const SimulationUser = ({ user }) => (
  <tr>
    <td>
      <Thumbnail image={user.avatar.thumbUrl} />
    </td>
    <td>
      {getUserName(user)}
      {!user.active && <>{" "}<Tag color="gray">Disabled</Tag></>}
      {!user.claimed && <>{" "}<Tag>Invited</Tag></>}
      {user.organizationAdmin && <>{" "}<Tag>Admin</Tag></>}
      <br />
      <span className="light">{user.organization.name}</span>
    </td>
    <td>
      {user.email}
    </td>
    <td>
      <TimeDiff time={user.createdAt} />
    </td>
    <td>
      {user.points}
    </td>
    <td>
      {user.claimed && (
        <Simulate userId={user.id} name={getUserName(user)} email={user.email}>
          {onTrigger => (
            <ActionButton icon="eye" onClick={onTrigger}>
              <Trans>Simulate</Trans>
            </ActionButton>
          )}
        </Simulate>
      )}
    </td>
  </tr>
);

const SimulationUsers = ({ fetching, query, users }) => (
  <Loader loading={fetching}>
    {users.length > 0 && (
      <Table>
        <thead>
          <tr>
            <th />
            <th>Name</th>
            <th>Email</th>
            <th>Created</th>
            <th>Points</th>
            <th className="actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <SimulationUser key={user.id} user={user} />
          ))}
        </tbody>
      </Table>
    )}
    {query && users.length === 0 && (
      <Warning>
        <Trans>No users to show!</Trans>
      </Warning>
    )}
  </Loader>
);

const Users = () => {
  const [state, setState] = useState({ fetching: false, query: "", users: [] });
  const onSearch = useCallback(
    async query => {
      if (query) {
        setState(value => ({ ...value, fetching: true, query }));

        const { users } = await client.adminAutocompleteUsers({ query });
        setState(value => ({ ...value, fetching: false, users }));
      } else {
        setState(value => ({ ...value, query, users: [] }));
      }
    },
    [setState]
  );

  return (
    <Panel limitWidth>
      <Panel.Heading primary>
        <Trans>All Users</Trans>
      </Panel.Heading>
      <Panel.Body>
        <p>
          <strong><Trans>Search All Users:</Trans></strong>
        </p>
        <SearchBar onSearch={onSearch} placeholder="Search" throttle={1000} />
        <SimulationUsers {...state} />
      </Panel.Body>
    </Panel>
  );
};

export default Users;
